import React, { Component } from 'react'
import ReactPlayer from 'react-player'
import { Layout, Card, Row, Col, Form, Select as _Select, Button, Modal } from 'antd';
import axios from 'axios';
import "antd/dist/antd.css";
import { withRouter } from 'react-router-dom';
import Template from '../interfaz/Template';
import { connect } from 'react-redux';
import emitirMensaje from '../../redux/actions/emitirMensaje'
import AuthenticatedComponent from '../AuthenticatedComponent'
import * as etiquetas from '../../ApplicationResources';
import errorImgModal from '../../img/error_icon.svg';
import infow_iconModal from '../../img/infow_icon.png';

const { Header, Sider, Footer, Content } = Layout;
let msjError = "";

export class Platica extends Component {

    state = {
        cargado: false,
        tipoMsj: 'info',
        msj: 'Validación de documentos en proceso.',
        tipoVida: {},
        msjError: "",
        abrirModalError: false,
        fechaCapsula:undefined,
        inhabilitaBoton:false,
        fechaFinCapsula:""
    }

    constructor(props) {
        // Calling the constructor of
        // Parent Class React.Component
        super(props);
        // Setting the initial state
        this.aspirante = this.props.getAspirante;
        this.submit = this.submit.bind(this);
        this.dataAsp = this.props.datosAspirante;
    }

    getTiposVida = () => {
        var jSonTipoVida = {
            "idProcesoElectoral": this.props.datosAspirante.idProcesoElectoral,
            "idDetalleProceso": this.props.datosAspirante.idDetalleProceso,
            "idParticipacion": this.props.datosAspirante.idParticipacion,
            "idConvocatoria" : this.props.datosAspirante.idConvocatoria
        }

        // Obtenido los datos del servidor
        const response = axios.post(process.env.REACT_APP_API_URL + '/ws_reclutaseycae_central/ws/obtineTipoVida'
            , jSonTipoVida
            , {
                headers: {
                    'Accept': 'application/json'
                    , 'Content-Type': 'application/json'
                    , 'Authorization': localStorage.getItem("jwt-token") 
                }
            }
        );
        response.then((res) => {
            console.log(res.data.entity.resultadoTipoVida)
            this.tipoVida = res.data.entity.resultadoTipoVida.tipoVida
            this.setState({ tipoVida: this.tipoVida })
            this.setState({fechaFinCapsula: res.data.entity.fechaCapsula})

            this.setState({abrirModalAviso1:(this.dataAsp.estatusRegistro!==3 && (this.state.fechaCapsula === null || this.state.fechaCapsula === undefined) || 
                (this.dataAsp.estatusRegistro===3 && (this.state.fechaCapsula === null || this.state.fechaCapsula === undefined)
                )) ? false:true});
    
            this.setState({abrirModalAviso2:(new Date() <= new Date(res.data.entity.fechaCapsula)) ? false:true});
            this.setState({
            inhabilitaBoton: ((this.state.fechaCapsula === null || this.state.fechaCapsula === undefined) 
                            && new Date() <= new Date(res.data.entity.fechaCapsula)) ? false:true
            })
        })

        
        return response.data;
    }

    getAspirante = () => {
        const { proceso } = this.props;
        const idCorte = proceso ? proceso.corte : 0;
        
        var jSonAspirante = {
            "idProcesoElectoral" : this.props.datosAspirante.idProcesoElectoral,
            "idDetalleProceso": this.props.datosAspirante.idDetalleProceso,
            "idAspirante": this.props.datosAspirante.idAspirante,
            "idParticipacion": this.props.datosAspirante.idParticipacion,
            "idCorte" : idCorte
        }

        // Obtenido los datos del servidor
        const response = axios.post(process.env.REACT_APP_API_URL + '/ws_reclutaseycae_central/ws/obtineAspirante'
            , jSonAspirante
            , {
                headers: {
                    'Accept': 'application/json'
                    , 'Content-Type': 'application/json'
                    , 'Authorization': localStorage.getItem("jwt-token") 
                }
            }
        );
        response.then((res) => {
            this.aspirante = res.data.entity.aspiranteRes.aspirante
            
            if (this.aspirante.estatusRegistro === 2 && this.aspirante.bObservacion === 1) {
                this.setState({ tipoMsj: 'warning' })
                this.setState({ msj: etiquetas.gral_observacion_documentos })
            } else if (this.aspirante.estatusRegistro === 3) {
                this.setState({ tipoMsj: 'ok' })
                this.setState({ msj: etiquetas.gral_documentos_validados })
            }
            if (this.props.datosUsuario.tipoUsuario === 'I') {
                this.setState({ tipoMsj: '' })
                this.setState({ msj: '' })
            }
            this.setState({fechaCapsula:res.data.entity.aspiranteRes.aspirante.fechaCapsula})
            
            
            
            this.props.emitirMensaje(
                {
                    id: 'mensajeUsuario',
                    tipoMensaje: this.state.tipoMsj,
                    contenido: this.state.msj,
                }
            );
            
                
        })
        return response.data;
    }

    ejecutaFunciones = () => {
        this.getTiposVida();
        this.getAspirante();
        this.setState({ cargado: true })
    }

    submit() {
        console.log('Entró al submit');
        this.setState({cargando: true});
        //axios.post(process.env.REACT_APP_API_URL + '/ws_reclutaseycae_central/ws/guardarCapsulaInduccion', {
        //    idDetalleProceso : this.props.datosAspirante.idDetalleProceso,
        //   idParticipacion : this.props.datosAspirante.idParticipacion,
        //    idAspirante : this.props.datosAspirante.idAspirante
        //},{
        //    headers: {
        //        'Content-Type': 'application/json'
        //        , 'Authorization': localStorage.getItem("jwt-token")        
        //    }
        //}).then(res => {
        //    this.setState({cargando: false});
        //    if(res.status === 200)
        //        this.props.datosAspirante.bPlatica=0;
        //        this.props.history.push('/Cuestionario');
        //}).catch(error => {
        //    console.error("Error Platica", error);
        //    this.setState({cargando: false});
        //   msjError = 'Ocurrio un error al guardar la fecha de la cápsula de inducción';
        //    this.setState({msjError: msjError, abrirModalError: true});
        //});
        this.props.history.push('/Cuestionario');
    }

    cerrarErrorModal() {
        this.setState({abrirModalError:false});
    }

    cerrarModalAviso(){
        this.setState({abrirModalAviso1:false,
            abrirModalAviso2:false})
    }

    render() {
        const tipoVida = this.state.tipoVida || {};
        const tipoUsuario = this.props.datosUsuario.tipoUsuario;
        return (
            <AuthenticatedComponent listo={this.ejecutaFunciones}>
                <Template guia={tipoUsuario === 'E'} bloqueado={!this.state.cargado} contenido={
                    <React.Fragment>
                        <Card title=" " bordered={false}>
                            <Row gutter={16}>
                                <Col sm={24} md={24} lg={24}>
                                    <h1>{etiquetas.etiqueta_ve_capsula_induccion}</h1>
                                </Col>
                                <Col id='colRP' sm={24} md={24} lg={24}>
                                    <ReactPlayer
                                        url={!this.state.inhabilitaBoton ? tipoVida.urlCapsula:'#'}
                                        className='react-player'
                                        controls
                                        width='640px'
                                        height='360px'
                                    />
                                </Col>
                            </Row>

                            <Footer>
                                <Row>
                                    <Col xs={0} sm={2} md={8} lg={8}></Col>
                                    <Col id='colBtn' xs={24} sm={20} md={8} lg={8}>
                                        <Button type="primary"
                                            className="button_style"
                                            id="btnPlatica"
                                            style={{ width: 220 }}
                                            htmlType="submit"
                                            onClick={this.submit}
                                            disabled={this.state.inhabilitaBoton}
                                        >
                                            Realiza tu evaluación
                                        </Button>
                                    </Col>
                                    <Col xs={0} sm={2} md={8} lg={8}></Col>
                                </Row>
                            </Footer>

                        </Card>
                    </React.Fragment>
                } />
                <Modal className="modalError"
                       title={<img  src={errorImgModal} id="img-error-modal"/>}
                       centered
                       onCancel={()=>this.cerrarErrorModal()}
                       visible={this.state.abrirModalError}
                       footer={false}
                       width={400}>
                    {this.state.msjError}
                </Modal>

                <Modal 
                       className="modalError"
                       title={<img  src={infow_iconModal} id="img-error-modal"/>}
                       closable={false}
                       visible={this.state.abrirModalAviso1}
                       footer={false}>
                    <div className='modal' style={{'fontSize': '16px' }}>
                        Ya visualizaste la capsula de inducción y realizaste tu evaluación.
                    </div>
                    <br/><br/>
                    <div id="modal_botones">
                        <Button  onClick={()=>this.cerrarModalAviso()}> Aceptar </Button>
                    </div>
                </Modal>

                <Modal 
                       className="modalError"
                       title={<img  src={infow_iconModal} id="img-error-modal"/>}
                       closable={false}
                       visible={this.state.abrirModalAviso2}
                       footer={false}>
                    <div className='modal' style={{'fontSize': '16px' }}>
                        La fecha para visualizar la capsula de inducción y realizar la evaluación ha concluído.
                    </div>
                    <br/><br/>
                    <div id="modal_botones">
                        <Button  onClick={()=>this.cerrarModalAviso()}> Aceptar </Button>
                    </div>
                </Modal>
            </AuthenticatedComponent>
        )
    }
}


const mapStateToProps = state => {
    var datosAspirante;
    var datosUsuario;
    var proceso = undefined;

    // Obtenemos el proceso seleccionado de la store de redux
    if(state.menu.estados)
        if(state.menu.estados[state.menu.idEstado].procesos)
            proceso = state.menu.estados[state.menu.idEstado].procesos[state.menu.idDetalle];

    if (state.user.currentUser)
        datosUsuario = state.user.currentUser;
    else
        datosUsuario = {};

    if (state.user.datosAspirante)
        datosAspirante = state.user.datosAspirante;

    return {
        datosAspirante: datosAspirante,
        datosUsuario: datosUsuario,
        proceso : proceso
    };
}





const msj = connect(mapStateToProps, { emitirMensaje })(Platica)
export default withRouter(Form.create({
    name: 'platicaInduccion'
})(msj));
